export enum InspectionStandard {
	PACP = 'PACP',
	MACP = 'MACP',
	MSCC = 'MSCC',
	WSA05 = 'WSA05',
}
